<template>
  <div>
    <gatherBasis :cells="cells" :type="type">
      <template #column>
        <el-table-column align="center" header-align="center" label="未检查人数" prop="notCheck" width="150px"/>
        <el-table-column align="center" header-align="center" label="检查人数" prop="sum" width="150px"/>
        <el-table-column v-for="item in cells" :label="item.name" align="center" header-align="center">
          <el-table-column :prop="item.prop" align="center" header-align="center" label="人数"/>
          <el-table-column :prop="item.prop+'Ratio'" align="center" header-align="center" label="百分比"/>
        </el-table-column>
      </template>
    </gatherBasis>
  </div>

</template>
<script>
import gatherBasis from "../components/gatherBasis.vue"
/*肺活量*/
export default {
  name: "gatherLung",
  components: {
    gatherBasis
  },
  data() {
    return {
      type: "lung",
      cells: [
        {prop: "r098_3", name: '优秀'},
        {prop: "r098_2", name: '良好'},
        {prop: "r098_1", name: '及格'},
        {prop: "r098_0", name: '不及格'}
      ]
    }
  },
  mounted() {
  },
  methods: {}
}
</script>
<style scoped>

</style>